export class AnalyzerInfoData {
    constructor(intrinsicPnL, PnL, greeks, whatIf) {
        this.intrinsicPnL = intrinsicPnL;
        this.PnL = PnL;
        this.greeks = greeks;
        this.whatIf = whatIf;
    }
}
